export default __webpack_public_path__ + "static/media/A4Unselect.64e839ed.svg";